// extracted by mini-css-extract-plugin
export default {"container":"container___OwRn6_contentrenderer"};
    if(module.hot) {
      // 1765466940969
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  